<template>
  <div class="search-wrap ml12 mr12 mb16">
    <div class="search-bar search-shadow">
      <!-- <i class="jfi-back-v2"></i> -->
      <input
        @click.prevent="triggerSearchModal($event)"
        class="search-query-input"
        id="searchQueryInput"
        type="text"
        name="searchQueryInput"
        placeholder="Search Pizzas, Sides &amp; more..."
      />
      <button
      @click.prevent="triggerSearchModal($event)"
        class="search-query-submit"
        id="searchCta"
        type="submit"
        name="searchCta"
      >
        <i class="jfi-search"></i>
      </button>
    </div>

    <!-- search modal -->
    <search-modal
      v-if="isSearchModalOpen"
      :showSearchModal="isSearchModalOpen"
      :moduleProps="moduleProps"
      @close="closeSearchModal()"
    ></search-modal>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import Utility from "../helpers/utility";
import setEvents from "../helpers/events";
import UserActivityTracking from "../helpers/UserActivityTracking";
import { projectBasePathWithFolder } from "../config/apiEndpoints";
import localStorageFunc from '../helpers/localStorageFunc';
import { keyMapsMutation } from "../helpers/storeKeys";

export default {
  name: "SearchProducts",
  props: ["moduleProps"],
  components: {
    SearchModal: defineAsyncComponent(() => import("./SearchModal.vue"))
  },
  methods: {
    triggerSearchModal(e) {
      if (!Utility.isSeparateMenuVariant()) {
        let url =
          projectBasePathWithFolder +
          Utility.getMenuCategory() +
          localStorageFunc.storeId() +
          Utility.getUrlQueryString();
        url = this.addShowSearchModalParam(url);
        window.location.href = url;
      }
      else {
        document.body.classList.add("body-stop-scroll-mobile");
        this.updateIsSearchModalOpen(true);
        //Amplitude Click event load
        const eventObj = Utility.amplitudeEventObj("click", "search", "3", {});
        setEvents("amplitude", "Click", eventObj);
        UserActivityTracking.searchClicked(0);
      }
    },
    closeSearchModal() {
      this.updateIsSearchModalOpen(false);
    },
    addShowSearchModalParam(url) {
      url = Utility.addUpdateParam(url, "showSearchModal", true);
      url = Utility.addUpdateParam(url, "scrollTo", "menuTop");
      return url;
    },
    updateIsSearchModalOpen(val) {
      this.$store.commit(keyMapsMutation.UPDATE_IS_SEARCH_MODAL_OPEN, val);
    },
  },
  computed: {
    isSearchModalOpen() {
      return this.$store.state.ProductItems.isSearchModalOpen;
    },
  }
};
</script>
